import { FormatMessage } from "../types";

export const buildLoader = (
  count: number = 5,
  formatMessage: FormatMessage,
): string => {
  const dots = Array(count).fill("<div></div>").join("");

  return `
    <div class="vst-dot-loader vst-dot-loader-size-large"
      role="img"
      aria-label="${formatMessage("base.loading-accessibility-claims")}"
      tabIndex="-1"
    >
      ${dots}
    </div>
  `;
};
